import AdvisoryList from "../../AdvisoryManagement/components/AdvisoryList"

interface Props {
    userProfile: any
}
const Intelligence = (props: Props) => {
    return (
        <div className="h-[calc(100vh-49px)] max-w-[1100px] m-auto">
            <AdvisoryList userType={props?.userProfile?.user_type} orgId={props?.userProfile?.org_id} partnerID={props?.userProfile?.partnerv2_id}/>
        </div>
    )
}

export default Intelligence